module.exports = __webpack_public_path__ + "img/ts1.2aab3d37.png";